"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCookbookMutationOptions = exports.updateCookbookMutation = void 0;
const client_1 = require("@apollo/client");
const cookbook_1 = require("../fragments/cookbook");
exports.updateCookbookMutation = client_1.gql `
  mutation UpdateCookbook($id: String!, $cookbook: CookbookInput!) {
    updateCookbook(id: $id, cookbook: $cookbook) {
      __typename
      errors {
        path
        message
      }
      cookbook {
        ...justCookbook
      }
    }
  }
  ${cookbook_1.justCookbookFragment}
`;
exports.updateCookbookMutationOptions = (variables) => ({
    variables,
});
//# sourceMappingURL=updateCookbook.js.map